<template>
  <div>
    <section v-if="showStartPage" class="start__screen-module" id="rcv__content">
      <v-start-page :heading="heading" :description="description" :ballotsCountedImage="ballotsCountedImage"
        :altText="startPageAltText" />
    </section>
    <div v-if="showHowVotesAreCounted" id="wrapper">
      <div v-show="!loader" class="container">
        <!-- <div class="rcv_header">
          <h3 v-if="heading">{{ heading }}</h3>
          <div v-if="description" v-html="description"></div>
        </div> -->
        <div class="rcv__heading-v1">
          <div v-if="count">
            <h1>

              {{
                `${roundValue[count - 1]}`
              }}
            </h1>
          </div>
        </div>
        <div class="rcv">
          <div class="chart-wrapper" :class="{ 'winner-active': count == 6 && final === true }">
            <div class="barchart-icon">
              <v-icon :step="count" :colorvalue="iconColor" :candidates="rowHeader" :votes="currentVotes"
                :isNext="isNext" :voterText="label" />
            </div>

            <div class="barChart">

              <div v-if="count == 6 && final == true" class="winner-announcement" :style="winnerDivStyle">
                <div class="winner-announcement-child">
                  <img v-if="winnerImageUrl" :src="winnerImageUrl" alt="Winner Image" class="winner-image" />
                  <p>{{ winnerText }}</p>
                </div>
              </div>

              <v-chart class="chart" ref="myEchart" :style="styleProps" :autoresize="true" :option="chartOptions" />
            </div>

          </div>

          <v-instructions v-if="instructionSet" :instruction="this.count" :disable="disablestart"
            :instructioncontent="instructionSet" ref="instruction" />

        </div>
      </div>
      <div v-show="loader">
        <div class="loader">
          <div class="dot-loader"></div>
          <div class="dot-loader dot-loader--2"></div>
          <div class="dot-loader dot-loader--3"></div>
        </div>
      </div>
    </div>
    <footer class="rcv__footer">
      <v-footer-button :buttonLabels="buttonLabel" :exitButtonLink="exitButtonLink" :instruction="this.count"
        :current-state="footerButtonState" v-on:onreset="resetGraph" v-on:onprevious="onprevious"
        :disable="disablestart" :start="start" :show-back-button="showBackButton" v-on:onnext="onnext"
        @start-clicked="startClicked" @backToStartPageClicked="backToStartPage" />
    </footer>
  </div>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import InstructionComponentV2 from "./components/PracticeRcvv2/InstructionComponentV2.vue";
import FooterButtonComponent from "./components/PracticeRcvv2/FooterButtonComponent.vue";
import RcvV2StartPage from "./components/PracticeRcvv2/Rcv2StartPage.vue";
import CandidateIconComponentV2 from "./components/PracticeRcvv2/CandidateIconComponentV2.vue"
import Pigeon from "../public/assets/rcv-images/pigion.png";
import axios from "axios";
import "../styles/main.css";
import {
  customColors,
  stepFivePurpleColors,
  stepFiveOrangeColors,
  getChartConfig,
  formatRounds,
  isSmallScreen,
  isMediumScreen,
  isLargeScreen
} from "./config/chart-config-v2";

import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from "echarts/components";

import { getAppConfig, getInitialRoundObj } from "./config/app-config";
import VChart, { THEME_KEY } from "vue-echarts";
import * as echarts from "echarts";

use([
  CanvasRenderer,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent
]);

let appData = getAppConfig();
let ballotWinnerTimer;

export default {
  name: "Rcv",
  inject: ["rcvV2PageId"],
  data() {
    return {
      winnerImageUrl: Pigeon,
      direction: null,
      count: 0,
      final: null,
      updatedOption: [],
      disablestart: false,
      styleProps: null,
      heading: "",
      description: "",
      stepHeadingText: "",
      ofText: "",
      instructionSet: null,
      rowHeader: null,
      winnerText: "",
      label: "",
      roundValue: null,
      loader: true,
      chartOptions: null,
      iconColor: [],
      iconName: [],
      footerButtonState: "initial",
      showHowVotesAreCounted: false,
      showStartPage: true,
      showBackButton: false,
      exitButtonLink: null,
      buttonLabel: null,
      // Add winnerDivStyle computed property for styling the custom winner div
      winnerDivStyle: {
        position: "absolute",
        left: isSmallScreen ? "0%" : "0%",
        top: isSmallScreen || isMediumScreen ? "0%" : "0%",
        fontFamily: "Whyte, sans-serif",
        lineHeight: "42px",
        color: customColors[1],
        fontWeight: 800,
        fontSize: isSmallScreen || isMediumScreen ? "26px" : "36px",
        zIndex: 10 // Make sure it appears above the chart
      },
      currentVotes: [],
      isNext: null,
      stepCount: null,
      startPageAltText: null
    };
  },
  components: {
    "v-instructions": InstructionComponentV2,
    "v-icon": CandidateIconComponentV2,
    "v-footer-button": FooterButtonComponent,
    "v-start-page": RcvV2StartPage,
    VChart
  },
  watch: {
    showHowVotesAreCounted(newVal) {
      if (newVal && this.count === 1) {
        this.$nextTick(() => {
          this.graphInitor();
        });
      }
    },
    count: function (newCount, oldCount) {
      this.initUpdateOption();
    }
  },
  methods: {
    backToStartPage() {
      this.count = 0;
      this.showStartPage = true;
      this.showHowVotesAreCounted = false;
      this.showBackButton = false;
    },
    startClicked: function () {
      this.count = 1;
      this.showBackButton = true;
      this.showStartPage = false;
      this.showHowVotesAreCounted = true;

      // Add these lines
      const round0 = getInitialRoundObj();
      this.updatedOption = { ...round0, hasVotingEnded: false };

      // Set initial vote values
      if (round0 && round0[0] && round0[0].data) {
        this.currentVotes = round0[0].data.slice(1).map(dataObj => dataObj.value || 0);
      }

      this.initUpdateOption();
      this.graphInitor(); // Add this line to initialize the chart

    },
    //On clicking previous ,previous logic is handling here
    onprevious: function () {
      this.isNext = false;
      this.goTo();

      this.disablestart = false;
      this.count = this.count - 1;
      this.direction = "prev";
      if (this.count < 1) {
        this.count = 1;
      }

      // Get the current series data before updating the graph
      const updatedOption = [...appData];
      const currentRound = updatedOption[this.count - 1] || { data: [] };
      // Skip the first value by starting from index 1
      this.currentVotes = currentRound.data.slice(1).map(dataObj => dataObj.value || 0);

      //initing the graph with updated changes
      this.initUpdateOption();
    },

    //used to initing the graph with latest option
    initUpdateOption: function () {
      let updatedOption;
      const eliminatedOpacity = 0.2;
      const afterEliminationOpacity = 0.05;

      updatedOption = [...appData].map(round => {
        return {
          ...round,
          data: round.data.map((dataObj, index) => {
            if (index == 4) {
              if (this.count === 3) {
                dataObj.itemStyle = {
                  ...dataObj.itemStyle,
                  opacity: eliminatedOpacity
                };
              }
              if (this.count === 2) {
                dataObj.itemStyle = {
                  ...dataObj.itemStyle,
                  opacity: 1
                };
              }
            }

            if (index === 3) {
              if (this.count === 4) {
                dataObj.itemStyle = {
                  ...dataObj.itemStyle,
                  opacity: eliminatedOpacity
                };
              }
              if (this.count === 3) {
                dataObj.itemStyle = {
                  ...dataObj.itemStyle,
                  opacity: 1
                };
              }
            }

            if (index === 6) {
              if (this.count === 5) {
                dataObj.itemStyle = {
                  ...dataObj.itemStyle,
                  opacity: eliminatedOpacity
                };
              }
              if (this.count === 4) {
                dataObj.itemStyle = {
                  ...dataObj.itemStyle,
                  opacity: 1
                };
              }
            }

            if (index === 2) {
              if (this.count === 6) {
                dataObj.itemStyle = {
                  ...dataObj.itemStyle,
                  opacity: eliminatedOpacity
                };
              }
              if (this.count === 5) {
                dataObj.itemStyle = {
                  ...dataObj.itemStyle,
                  opacity: 1
                };
              }
            }

            return dataObj;
          })
        };
      });

      if (this.count == 6) {
        ballotWinnerTimer = setTimeout(() => {
          this.final = true;
          updatedOption = appData.map(round => {
            return {
              ...round,
              data: round.data.map((dataObj, index) => {
                if (index === 1) {
                  dataObj.itemStyle = {
                    ...dataObj.itemStyle,
                    color: customColors[1]
                  };
                }
                if (index === 2) {
                  dataObj.itemStyle = {
                    ...dataObj.itemStyle,
                    opacity: afterEliminationOpacity
                  };
                }
                if (index === 3) {
                  dataObj.itemStyle = {
                    ...dataObj.itemStyle,
                    opacity: afterEliminationOpacity
                  };
                }
                if (index === 4) {
                  dataObj.itemStyle = {
                    ...dataObj.itemStyle,
                    opacity: afterEliminationOpacity
                  };
                }
                if (index === 5) {
                  dataObj.itemStyle = {
                    ...dataObj.itemStyle,
                    color: customColors[5]
                  };
                }
                if (index === 6) {
                  dataObj.itemStyle = {
                    ...dataObj.itemStyle,
                    opacity: afterEliminationOpacity
                  };
                }
                return dataObj;
              })
            };
          });
          this.disablestart = false;
          this.updateGraph(updatedOption);
        }, 1500);
      }
      if (this.count === 5 && this.direction === "prev") {
        this.final = false;
        updatedOption = appData.map((round, index) => {
          round.data[1] = {
            ...round.data[1],
            itemStyle: {
              color: stepFivePurpleColors[index]
            }
          };
          round.data[5] = {
            ...round.data[5],
            itemStyle: {
              color: stepFiveOrangeColors[index]
            }
          };
          return round;
        });
      }
      updatedOption = appData.map((round, roundIndex) => {
        if (roundIndex > this.count) {
          return {
            ...round,
            data: round.data.map(dataObj => {
              return {
                ...dataObj,
                value: 0
              };
            })
          };
        }
        return round;
      });

      this.updateGraph(updatedOption);
    },

    //on clicking the next, next logic is handlling here
    onnext: function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.isNext = true;
      this.goTo();
      this.direction = "next";
      this.final = false;

      let vm = this;
      this.count = this.count + 1;
      if (this.count > 5) {
        this.count = 6;
        this.disablestart = true;
      }
      // Get the current series data before updating the graph
      const updatedOption = [...appData];
      const currentRound = updatedOption[this.count - 1] || { data: [] };
      // Skip the first value by starting from index 1
      this.currentVotes = currentRound.data.slice(1).map(dataObj => dataObj.value || 0);
      this.initUpdateOption();

    },

    //initializing the initial graph
    initInitialGraph: function () {
      this.goTo();
      this.disablestart = false;

      this.count = 0;
      this.count = this.count + 1;
      const round0 = getInitialRoundObj();
      this.updatedOption = { ...round0, hasVotingEnded: false };

      // Set initial vote values
      if (round0 && round0[0] && round0[0].data) {
        this.currentVotes = round0[0].data.map(dataObj => dataObj.value || 0);
      }
      this.graphInitor();
    },

    goTo: function () {
      let element = document.getElementById("wrapper");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "center"
        });
      }

    },

    //reseting the graph when the start is clicked
    resetGraph: function () {
      // this.disablestart = false;
      this.goTo();

      const initialRound = getInitialRoundObj();
      appData = getAppConfig();

      // MODIFIED: Get chart config without title property
      const chartConfig = getChartConfig({
        stepValue: 1,
        hasVotingEnded: false,
        axisData: this.rowHeader,
        winnerText: this.winnerText
      });

      const chartOptions = {
        ...chartConfig,
        series: initialRound
      };
      // this.updatedOption = chartOptions;
      this.chart = this.$refs.myEchart;
      this.count = 0;
      this.count = this.count + 1;
      this.chart.setOption({}, true);
      this.chart.setOption(chartOptions, true);
    },

    // initializing the graph with updated option
    updateGraph: function (updatedOption) {
      var currentOption = [];
      if (this.count == 1) {
        currentOption = updatedOption.slice(0, this.count);
      } else if (this.count == 6 && this.final == true) {
        currentOption = updatedOption.slice(6, 7);
      } else {
        currentOption = updatedOption.slice(1, this.count);
      }

      const updatedBallotRounds = formatRounds(
        currentOption,
        this.count,
        this.label
      );

      if (updatedBallotRounds.length > 0) {
        updatedBallotRounds.forEach(round => {
          if (round.label) {
            round.label.show = false;
          }
        });
      }

      this.updatedOption = updatedBallotRounds;
      const stepValue = this.count;
      let hasVotingEnded = false;
      if (this.updatedOption[0] != null) {
        hasVotingEnded = this.updatedOption[0].hasVotingEnded;
        if (this.count == 6 && this.final == true) {
          hasVotingEnded = true;
        }
      }

      const axisData = this.rowHeader;
      const winnerText = this.winnerText;

      // MODIFIED: Get chart config without title property
      const chartConfig = getChartConfig({
        stepValue,
        hasVotingEnded,
        axisData,
        winnerText
      });

      const updatedOptions = {
        ...chartConfig,
        series: updatedBallotRounds
      };

      if (Object.keys(this.$refs).length > 0) {
        this.chart = this.$refs.myEchart;

        this.chart.setOption(updatedOptions, {
          notMerge: true,
          lazyUpdate: false,
          silent: false
        });
      }
    },

    //initializing the graph with default value
    graphInitor: function () {
      const stepValue = this.count;
      const ballotRounds = this.updatedOption;
      const hasVotingEnded = this.updatedOption.hasVotingEnded;

      // MODIFIED: Get chart config without title property
      const chartConfig = getChartConfig({
        stepValue,
        hasVotingEnded,
        axisData: this.rowHeader,
        winnerText: this.winnerText
      });

      const chartOptions = {
        ...chartConfig,
        series: ballotRounds
      };

      this.chart = this.$refs.myEchart;
      this.chart.setOption(chartOptions, true);
    },

  },

  created() {
    let testData;
    this.styleProps = isSmallScreen
      ? { width: "100%", height: "571px" }
      : { width: "100%", height: "570px" };
    let currentInstance = this;
    let cultureDefault = document.documentElement.lang;
    let culture = document.getElementById("ApplicationCulture").val;
    let pageId = window.rcvV2PageId;
    let url = "";
    const location = window.location;
    if (culture != null) {
      url = `${location.origin}/v2practicercv/getRcV2?pageId=${pageId}&culture=${culture}`;
      // url = `http://localhost:63238/v2practicercv/getRcV2?pageId=4949&culture=en-Us`;
     // url = `https://votingnycdev-v13-frontend-qa.azurewebsites.net/v2practicercv/getRcV2?pageId=2312&culture=en-Us`;
    } else {
      url = `${location.origin}/v2practicercv/getRcV2?pageId=${pageId}&culture=${cultureDefault}`;
      // url = `http://localhost:63238/v2practicercv/getRcV2?pageId=4949&culture=en-Us`;
      //url = `https://votingnycdev-v13-frontend-qa.azurewebsites.net/v2practicercv/getRcV2?pageId=2312&culture=en-Us`;
    }

    const axios = require("axios");
    currentInstance.axios
      .get(url, {})
      .then(response => {
        currentInstance.loader = true;
        if (response.status == 200) {
          const data = response.data.responseObject;
          // testData = response.data.responseObject;

          this.heading = data.heading;
          this.description = data.description;
          this.ballotsCountedImage = data.ballotsCountedImage;
          this.startPageAltText = data.altText;
          this.start = data.start;
          this.stepHeadingText = data.stepHeadingText;
          this.instructionSet = data.steps;
          this.exitButtonLink = data.exitButtonLink;
          this.roundValue = data.steps.map(step => step.stepTitle);
          this.buttonLabel = data.steps.map(step => step.buttonLabel);

          // this.rowHeader = data.rowHeaders.map(item => ({
          //   id: item.id,
          //   candidateName: item.candidateName,
          //   description: item.description,
          //   imageUrl: item.imageUrl,
          //   color: item.color
          // }));
          this.rowHeader = [

            ...data.rowHeaders.map(item => ({
              id: item.id,
              candidateName: item.candidateName ? item.candidateName : "",
              description: item.description,
              imageUrl: item.imageUrl,
              color: item.color,
              altText: item.altText

            })),
            { id: null, candidateName: null, description: null, imageUrl: null, color: null },
          ];
          this.winnerText = (data.resultText || "").replace(/\\n/g, "\n");
          this.label = data.voteText;
          let labelColor = [
            "#fdf751",
            "#221649",
            "#4ba3b7",
            "#ed7aca",
            "#eb5534",
            "#367d54"
          ];
          this.iconColor = labelColor;
          this.iconName = data.rowHeaders;

          setTimeout(function () {
            currentInstance.initUpdateOption();
            currentInstance.loader = false;
          }, 1000);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  },

  mounted() {
    if (this.showHowVotesAreCounted) {
      this.initInitialGraph();
    }
  },

  unmounted() {
    if (ballotWinnerTimer !== undefined) {
      clearTimeout(ballotWinnerTimer);
    }
  }
};
</script>

<style scoped>
.chart-wrapper {
  position: relative;
}

.winner-announcement {
  position: absolute;
  z-index: 2 !important;
  white-space: pre-line;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 30px;
  pointer-events: none;
}

.winner-announcement-child {
  width: 414px;
  height: 414px;
  border-radius: 50%;
  border: 14.64px solid #367d54;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  flex-direction: column;
}

.winner-announcement-child p {
  font-size: 34px;
  line-height: 1.14;
  color: #22144A;
  font-weight: 850;
  margin-top: 8px;
  text-align: center;
}

@media screen and (max-width: 767px) {
  .winner-announcement-child {
    width: 339px;
    height: 339px;
  }

  .winner-announcement-child p {
    font-size: 28px;
  }

  .winner-announcement-child img {
    max-width: 170px;
  }
}

@media screen and (max-width: 374px) {
  .winner-announcement-child {
    width: 280px;
    height: 280px;
  }

  .winner-announcement-child p {
    font-size: 20px;
  }

  .winner-announcement-child img {
    max-width: 140px;
  }
}
</style>



// WEBPACK FOOTER //
// src/RcvV2.vue